var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplayLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60476 30.4513L3.5211 30.3684C3.19344 30.0093 3 29.4516 3 28.7295V28.8995V3.10374C3 3.1014 3 3.09965 3 3.09779C3 3.1 3 3.10187 3 3.1042V3.27461C3 2.49267 3.22553 1.90365 3.60341 1.55047L17.554 16.0014L3.60476 30.4513ZM3 3.09639C3 3.03212 3.00169 2.96972 3.00484 2.90825C3.00169 2.96925 3 3.03212 3 3.09639ZM3.00484 2.90545C3.00484 2.90464 3.00484 2.9037 3.00518 2.90277C3.00484 2.9037 3.00484 2.90464 3.00484 2.90545ZM3.00518 2.89729C3.00518 2.89682 3.00518 2.89635 3.00518 2.89589C3.00518 2.89635 3.00518 2.89682 3.00518 2.89729Z",
    fill: "url(#paint0_linear_7202_104864)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2061 20.9901L22.3122 20.9277L27.8215 17.6851C28.3468 17.3758 28.6968 17.0008 28.8715 16.604C28.6973 17.0008 28.3471 17.3762 27.8215 17.6855L22.3122 20.9282L22.2061 20.9901V20.9901ZM22.2075 20.8193L17.5566 16.0007L22.207 11.183L27.8215 14.4871C28.5345 14.9068 28.9347 15.4476 29.0016 16.0002C29.0016 16.0007 29.0016 16.0016 29.0016 16.0025C28.9347 16.5538 28.5345 17.0951 27.8215 17.5147L22.2075 20.8193",
    fill: "url(#paint1_linear_7202_104864)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59837 31C4.20867 31 3.86863 30.8687 3.60346 30.6209L3.60391 30.6204C3.86908 30.8683 4.20957 31 4.59927 31C4.63305 31 4.66739 30.999 4.70219 30.9973C4.66694 30.999 4.63215 31 4.59837 31V31ZM4.59882 30.8291C4.20912 30.8295 3.86908 30.6979 3.60391 30.45V30.4497L17.5532 15.9997L22.204 20.8182L5.86025 30.4378C5.40806 30.7033 4.97963 30.8291 4.59882 30.8291V30.8291ZM3.59997 30.6177C3.57531 30.5945 3.5511 30.5699 3.52734 30.5444L3.59997 30.6177Z",
    fill: "url(#paint2_linear_7202_104864)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5541 16.0001L3.60352 1.54918C3.86868 1.30179 4.20828 1.17058 4.59753 1.17058C4.97935 1.17058 5.40812 1.29678 5.86121 1.56283L22.2045 11.1823L17.5541 16.0001V16.0001ZM22.3097 11.0735L5.86121 1.39254C5.40812 1.12637 4.97935 1.00017 4.59753 1.00017C4.59573 1.00017 4.59449 1.00017 4.59269 1.00017C4.59494 1.00017 4.59663 1.00017 4.59933 1.00017C4.98024 1.00017 5.40857 1.1259 5.86121 1.39207L22.3097 11.0735V11.0735Z",
    fill: "url(#paint3_linear_7202_104864)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70342 30.9981C5.05743 30.9771 5.44938 30.8509 5.86149 30.609L22.2039 20.99L5.86149 30.609C5.44972 30.8514 5.05743 30.9771 4.70342 30.9981V30.9981ZM3.60469 30.6217L3.6012 30.6186C3.60244 30.6195 3.60379 30.6208 3.60469 30.6217ZM3.52858 30.5452L3.52148 30.538V30.5375C3.52419 30.5402 3.52633 30.5429 3.52858 30.5452Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2012 20.9901L22.3081 20.9277L22.2012 20.9901Z",
    fill: "url(#paint4_linear_7202_104864)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60246 30.9999C4.21276 30.9999 3.87227 30.8682 3.6071 30.6203L3.60665 30.6208C3.60575 30.6199 3.6044 30.6186 3.60316 30.6177L3.53053 30.5443C3.52828 30.542 3.52614 30.5393 3.52344 30.5366L3.6071 30.4499C3.87227 30.6978 4.21231 30.8295 4.60201 30.829C4.98282 30.829 5.41125 30.7033 5.86344 30.4377L22.2072 20.8182L22.3119 20.9266L22.2059 20.989L5.86344 30.6081C5.45133 30.85 5.05938 30.9762 4.70538 30.9972C4.67058 30.9989 4.63624 30.9999 4.60246 30.9999",
    fill: "url(#paint5_linear_7202_104864)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5211 30.5381C3.19344 30.1789 3 29.6213 3 28.8992V28.8987C3 29.6213 3.19344 30.1785 3.5211 30.5376V30.5381",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5211 30.5381C3.19344 30.1789 3 29.6218 3 28.8992V28.7292C3 29.4514 3.19344 30.009 3.5211 30.3681L3.60476 30.4511L3.5211 30.5381",
    fill: "url(#paint6_linear_7202_104864)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52344 30.538L3.60775 30.451V30.4514L3.52344 30.538",
    fill: "url(#paint7_linear_7202_104864)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8691 16.6043C28.9564 16.4075 29.0003 16.2052 29.0003 16.0028C29.0003 16.0025 29.0003 16.002 29.0003 16.002C29.0003 16.2047 28.9564 16.407 28.8691 16.6043Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3078 20.9277L22.2031 20.8192L27.8171 17.5146C28.5301 17.0951 28.9304 16.5537 28.9973 16.0024C28.9973 16.2048 28.9537 16.407 28.8671 16.6039C28.6925 17.0007 28.3424 17.3757 27.8171 17.685L22.3078 20.9277Z",
    fill: "url(#paint8_linear_7202_104864)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0004 16.0008V16.0003C29 15.3902 28.6063 14.7802 27.8203 14.3172L22.311 11.0746H22.3105L22.311 11.0742L27.8203 14.3168C28.6072 14.7797 29.0013 15.3906 29.0004 16.0008Z",
    fill: "#404040"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9977 16.0001C28.9308 15.4474 28.5305 14.9066 27.8176 14.4869L22.2031 11.1828L22.3078 11.0743H22.3083L27.8176 14.317C28.6036 14.7799 28.9973 15.3899 28.9977 16.0001Z",
    fill: "url(#paint9_linear_7202_104864)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.09749C3 3.09702 3 3.09656 3 3.09609C3 3.09656 3 3.09702 3 3.09749ZM3.00484 2.90795C3.00484 2.90702 3.00484 2.90609 3.00484 2.90515C3.00484 2.90609 3.00484 2.90702 3.00484 2.90795ZM3.00518 2.90247C3.00518 2.9006 3.00518 2.89885 3.00518 2.89699C3.00518 2.89885 3.00518 2.9006 3.00518 2.90247ZM3.00518 2.89559C3.07037 1.69737 3.69934 1.00523 4.58909 1.00115C4.20333 1.00348 3.86734 1.1347 3.60431 1.38023V1.37976L3.60116 1.38302C3.57346 1.40892 3.54711 1.43633 3.5211 1.46455C3.22553 1.78846 3.03907 2.27367 3.00518 2.89559Z",
    fill: "#404040"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.27441V3.10401C3 3.10167 3 3.09981 3 3.09759C3 3.09712 3 3.09666 3 3.09619C3 3.03192 3.00169 2.96906 3.00484 2.90805C3.00484 2.90712 3.00484 2.90619 3.00484 2.90526C3.00484 2.90444 3.00484 2.90351 3.00518 2.90257C3.00518 2.90071 3.00518 2.89896 3.00518 2.89709C3.00518 2.89662 3.00518 2.89616 3.00518 2.89569C3.03907 2.27378 3.22553 1.78856 3.5211 1.46465L3.60341 1.55027C3.22553 1.90345 3 2.49247 3 3.27441V3.27441ZM3.60116 1.38312L3.60431 1.37986C3.60341 1.38126 3.60206 1.38219 3.60116 1.38312Z",
    fill: "url(#paint10_linear_7202_104864)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2068 11.1824L5.86344 1.56293C5.41035 1.29687 4.98158 1.17067 4.59976 1.17067C4.21051 1.17067 3.87091 1.30189 3.60575 1.54928L3.52344 1.46367C3.54945 1.43544 3.5758 1.40803 3.60349 1.38214C3.60439 1.3812 3.60575 1.38027 3.60665 1.37934C3.86967 1.13381 4.20567 1.0026 4.59143 1.00026C4.59233 1.00026 4.59357 1.00026 4.59492 1.00026C4.59672 1.00026 4.59796 1.00026 4.59976 1.00026C4.98158 1.00026 5.41035 1.12646 5.86344 1.39263L22.3119 11.0736L22.3115 11.074L22.2068 11.1824Z",
    fill: "url(#paint11_linear_7202_104864)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7202_104864",
    x1: 16.317,
    y1: 2.83162,
    x2: -3.24563,
    y2: 21.7166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7202_104864",
    x1: 29.8703,
    y1: 16.0014,
    x2: 2.62507,
    y2: 16.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7202_104864",
    x1: 19.7247,
    y1: 18.6769,
    x2: -6.80368,
    y2: 44.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7202_104864",
    x1: -0.0123295,
    y1: -7.12299,
    x2: 11.8337,
    y2: 4.31263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7202_104864",
    x1: 29.9251,
    y1: 16.0017,
    x2: 2.4674,
    y2: 16.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7202_104864",
    x1: 19.7279,
    y1: 18.6768,
    x2: -6.8005,
    y2: 44.2862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7202_104864",
    x1: 16.317,
    y1: 2.83139,
    x2: -3.24559,
    y2: 21.7164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7202_104864",
    x1: 19.855,
    y1: 18.6788,
    x2: -6.67875,
    y2: 44.4954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7202_104864",
    x1: 29.866,
    y1: 16.0013,
    x2: 2.62072,
    y2: 16.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7202_104864",
    x1: 29.8664,
    y1: 16.0012,
    x2: 2.62118,
    y2: 16.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7202_104864",
    x1: 16.317,
    y1: 2.83142,
    x2: -3.24563,
    y2: 21.7164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7202_104864",
    x1: -0.0100991,
    y1: -7.12289,
    x2: 11.8359,
    y2: 4.31273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayLogo);
export default __webpack_public_path__ + "static/media/googleplay_logo.09420c1522f76b914765d67891862662.svg";
export { ForwardRef as ReactComponent };